import React, { useState } from 'react';
import { Paper, Tab, Tabs } from '@material-ui/core';

import { BulkASNUpload } from 'components/fbm/bulkupload/BulkASNUpload';
import { FBMAccountPicker, TabPanel } from 'shared';
import { useIsFeatureOn } from 'shared/hooks/featureFlags/useIsFeatureOn';

import { CreateASN } from './createASN';
import { ViewASN } from './viewASN';

const BULK_ASN_FEATURE_FLAG = 'FBM_BULK_ASN';

function FBMAsn() {
    const [selectedTab, setSelectedTab] = useState('0');
    const { data: isFeatureOn } = useIsFeatureOn(BULK_ASN_FEATURE_FLAG);
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <FBMAccountPicker />
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab id="ViewLittleSpoonASN_Tab" label="View" value="0" />
                <Tab id="CreateLittleSpoonASN_Tab" label="Create" value="1" />
                <Tab id="BulkLittleSpoonASN_Tab" label="Bulk Upload" value="2" disabled={!isFeatureOn} />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <ViewASN />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="1">
                <CreateASN />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="2">
                <BulkASNUpload />
            </TabPanel>
        </Paper>
    );
}

export { FBMAsn };
